import { GameOptions } from '@mythos/game/GameOptions';
import nullthrows from 'nullthrows';
import { graphql } from './generated/gql';
import { executeGQL } from './GraphQLHelpers';

export default class LobbyMutator {
  private _session: any;
  private _lobbyID: string;
  constructor(session: any, lobby_id: string) {
    this._session = session;
    this._lobbyID = lobby_id;
  }

  async addBot(bot_name: string) {
    return await executeGQL(ADD_BOT_MUTATION, {
      lobbyID: this._lobbyID,
      botName: bot_name,
    });
  }
  // returns gameID
  async startGame(): Promise<string> {
    const result = await executeGQL(START_GAME_MUTATION, {
      lobbyID: this._lobbyID,
    });
    return nullthrows(result.data?.lobbyStartGame?.id);
  }
  async setGameOption<T extends keyof GameOptions>(
    option: T,
    value: GameOptions[T],
  ) {
    return await executeGQL(SET_GAME_OPTION_MUTATION, {
      lobbyID: this._lobbyID,
      option,
      value,
    });
  }
  async setModule(module: string, enabled: boolean) {
    return await executeGQL(SET_MODULE_MUTATION, {
      lobbyID: this._lobbyID,
      module,
      enabled,
    });
  }
  async joinGame() {
    return await executeGQL(JOIN_LOBBY_MUTATION, {
      lobbyID: this._lobbyID,
    });
  }
  async leaveLobby() {
    return await executeGQL(REMOVE_PLAYER_MUTATION, {
      lobbyID: this._lobbyID,
      playerID: this._session.getUserID(),
    });
  }
  async kickPlayer(player_id: string) {
    return await executeGQL(REMOVE_PLAYER_MUTATION, {
      lobbyID: this._lobbyID,
      playerID: player_id,
    });
  }
}

const ADD_BOT_MUTATION = graphql(`
  mutation AddBot($lobbyID: ID!, $botName: String!) {
    lobbyAddBot(lobbyID: $lobbyID, botName: $botName) {
      sequenceID
    }
  }
`);

const REMOVE_PLAYER_MUTATION = graphql(`
  mutation RemovePlayer($lobbyID: ID!, $playerID: ID!) {
    lobbyRemovePlayer(lobbyID: $lobbyID, playerID: $playerID) {
      sequenceID
    }
  }
`);

const START_GAME_MUTATION = graphql(`
  mutation StartGame($lobbyID: ID!) {
    lobbyStartGame(lobbyID: $lobbyID) {
      id
      sequenceID
    }
  }
`);

const SET_GAME_OPTION_MUTATION = graphql(`
  mutation SetGameOption(
    $lobbyID: ID!
    $option: String!
    $value: GameOptionValue!
  ) {
    lobbySetGameOption(lobbyID: $lobbyID, option: $option, value: $value) {
      sequenceID
    }
  }
`);

const SET_MODULE_MUTATION = graphql(`
  mutation SetModule($lobbyID: ID!, $module: String!, $enabled: Boolean!) {
    lobbySetModule(lobbyID: $lobbyID, module: $module, enabled: $enabled) {
      sequenceID
    }
  }
`);

const JOIN_LOBBY_MUTATION = graphql(`
  mutation JoinLobby($lobbyID: ID!) {
    lobbyJoin(lobbyID: $lobbyID) {
      sequenceID
    }
  }
`);
